export interface BusinessProfile {
	Id;
	RegisteredCompanyName;
	CompanyDescription;
	CompanyRegistrationNumber;
	CategoryId;
	Category;
	ServiceProduced;
	OwnerName;
	AdditionalOwnerName;
	MobileNumber;
	EmailAddress;
	NumberOfMonthsOperational;
	HasRegisteredDomain;
	Website;
	Address;
	IdDocumentId;
	CipcDocumentId;
	IncomeTaxNumber;
	VatNumber;
	PayeNumber;
	TaxClearanceDocumentId;
	DateTaxClearanceExpires;
	CoidaNumber;
	DateCoidaExpires;
	BbeeLevel;
	DateBeeExpires;
	BeeCertificateDocumentId;
	Province;
	ProvinceId;
}

export class CreateBusinessProfile {
	UserId;
	Id;
	RegisteredCompanyName;
	CompanyDescription;
	CompanyRegistrationNumber;
	CategoryId;
	ServiceProduced;
	OwnerName;
	AdditionalOwnerName;
	MobileNumber;
	EmailAddress;
	NumberOfMonthsOperational;
	HasRegisteredDomain;
	Website;
	Address;
	IdDocumentId;
	CipcDocumentId;
	IncomeTaxNumber;
	VatNumber;
	PayeNumber;
	TaxClearanceDocumentId;
	DateTaxClearanceExpires;
	CoidaNumber;
	DateCoidaExpires;
	BbeeLevel;
	DateBeeExpires;
	BeeCertificateDocumentId;
	Province;
	ProvinceId;
	constructor(item: BusinessProfile) {
		this.Id = item.Id;
		this.RegisteredCompanyName = item.RegisteredCompanyName;
		this.CompanyDescription = item.CompanyDescription;
		this.CompanyRegistrationNumber = item.CompanyRegistrationNumber;
		this.CategoryId = item.CategoryId;
		this.ServiceProduced = item.ServiceProduced;
		this.OwnerName = item.OwnerName;
		this.AdditionalOwnerName = item.AdditionalOwnerName;
		this.MobileNumber = item.MobileNumber;
		this.EmailAddress = item.EmailAddress;
		this.NumberOfMonthsOperational = item.NumberOfMonthsOperational;
		this.HasRegisteredDomain = item.HasRegisteredDomain;
		this.Website = item.Website;
		this.Address = item.Address;
		this.IdDocumentId = item.IdDocumentId;
		this.CipcDocumentId = item.CipcDocumentId;
		this.IncomeTaxNumber = item.IncomeTaxNumber;
		this.VatNumber = item.VatNumber;
		this.PayeNumber = item.PayeNumber;
		this.TaxClearanceDocumentId = item.TaxClearanceDocumentId;
		this.DateTaxClearanceExpires = new Date(item.DateTaxClearanceExpires);
		this.CoidaNumber = item.CoidaNumber;
		this.DateCoidaExpires = new Date(item.DateCoidaExpires);
		this.BbeeLevel = item.BbeeLevel;
		this.DateBeeExpires = new Date(item.DateBeeExpires);
		this.BeeCertificateDocumentId = item.BeeCertificateDocumentId;
		this.Province = item.Province;
	}
}



// WEBPACK FOOTER //
// ./src/app/models/inModels/BusinessProfile.ts